import { getPlatform } from './config';

function isAbsoluteUrl(path: string): boolean {
  return /^https?:\/\//i.test(path);
}

function mediaBase(): string {
  return getPlatform().mediaBaseUrl.replace(/\/$/, '');
}

export function getImageUrl(imagePath?: string | null): string | null {
  if (!imagePath) return null;
  // Link-preview OG images may be stored as full URLs — pass them through.
  if (isAbsoluteUrl(imagePath)) return imagePath;
  return `${mediaBase()}/block-images/${imagePath}`;
}

export function getAvatarUrl(avatarPath?: string | null): string | null {
  if (!avatarPath) return null;
  if (isAbsoluteUrl(avatarPath)) return avatarPath;
  return `${mediaBase()}/avatars/${avatarPath}`;
}
